import React from 'react';
import MarkdownView from 'react-showdown';
import styles from './styles.module.scss';

type ItemFaqProps = {
    data: any
}

const ItemFaq = (props: ItemFaqProps) => {

  const data = props.data;

  return (<>
    <div className={styles.item}>
      <h3 className={styles.pregunta}>{data.attributes.pregunta}</h3>
      <h4 className={styles.respuesta}>
        <MarkdownView
          markdown={data.attributes.respuesta}
          options={{ tables: true, emoji: true }}
          style={{ lineHeight: "1.816rem", listStylePosition: "inside" }}
        />
      </h4>

    </div>
  </>);
};

export default ItemFaq;
